import Grid from '@material-ui/core/Grid/Grid';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form, formValueSelector } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';

import { getDialogContextValue } from '../../../../redux/selectors';

import ReduxDialog from '../../../Common/ReduxDialog';

import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { savePrinterFormHandler } from '../../../../redux/routines';
import { renderSelect, renderTextField } from '../../../../utils/reduxforms';
import { required, ip } from '../../../../utils/formvalidation';
import { PRINTER_DIALOG } from '../../../../redux/constants/dialogs';

import styles from './styles';

class PrinterDialog extends Component {
  state = {};

  handleDiscard = () => {
    this.props.hideDialog(PRINTER_DIALOG);
  };

  handleSave = () => {
    console.log('handleSave');
  };

  render() {
    const { handleSubmit, initialValues, connection } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={this.handleDiscard}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        onClick={() => this.props.submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        title={initialValues.get('name') || 'Add Printer'}
        subTitle={'Add a label printer for high speed label printing'}
        actions={actions}
        name={PRINTER_DIALOG}
        onRequestClose={this.handleDiscard}
        bodyStyle={styles.body}
      >
        <Form name={PRINTER_DIALOG} onSubmit={handleSubmit(savePrinterFormHandler)} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth
                validate={[required]}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="type"
                component={renderSelect}
                label="Type"
                fullWidth
                validate={[required]}
              >
                <MenuItem key="zebra" value="zebra">Zebra</MenuItem>
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="connection"
                component={renderSelect}
                label="Connection"
                fullWidth
                validate={[required]}
              >
                <MenuItem key="network" value="network">Network</MenuItem>
                <MenuItem key="usb" value="usb">USB</MenuItem>
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="ip"
                component={renderTextField}
                label="IP"
                fullWidth
                disabled={connection !== 'network'}
                validate={connection === 'network' ? [required, ip] : []}
              />
            </Grid>
          </Grid>
        </Form>

      </ReduxDialog>
    );
  }
}

PrinterDialog.propTypes = {
  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: PRINTER_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog(PRINTER_DIALOG);
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(PrinterDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const selector = formValueSelector(PRINTER_DIALOG);

  return {
    initialValues: getDialogContextValue(state)(PRINTER_DIALOG, 'printer'),
    connection: selector(state, 'connection'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/Printers/PrinterDialog/index.js